import { Chart as ChartJS } from 'chart.js/auto'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import React, { useEffect, useMemo, useState } from 'react'
import { Bar, Doughnut, Line, Radar } from 'react-chartjs-2'
import { BsDownload, BsGraphUp, BsLightningFill, BsTable } from 'react-icons/bs'
import { FaArrowDown, FaArrowUp, FaBox, FaChartBar, FaChartLine, FaChartPie, FaDollarSign, FaFilePdf, FaFilter, FaShoppingCart, FaTrophy, FaTruck } from 'react-icons/fa'
import { MdOutlineAutoGraph, MdOutlineInsights } from 'react-icons/md'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Navbar from '../../components/navbar/navbar.jsx'
import apinode from '../../services/apinode'

dayjs.extend(isSameOrBefore)
pdfMake.addVirtualFileSystem(pdfFonts)

const css = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=DM+Mono:wght@400;500&display=swap');
  :root {
    --bg:#f0f2f8;--surface:#ffffff;--surface2:#f7f8fc;--border:#e4e7ef;--border2:#cdd1df;
    --text:#0d1117;--sub:#5b6578;--muted:#8c94a6;
    --blue:#2563eb;--blue-lt:#eff4ff;--blue-mid:#dbeafe;--blue-dk:#1d4ed8;
    --green:#059669;--green-lt:#ecfdf5;--red:#dc2626;--red-lt:#fef2f2;
    --amber:#d97706;--amber-lt:#fffbeb;--purple:#7c3aed;--purple-lt:#f5f3ff;
    --orange:#ea580c;--orange-lt:#fff7ed;--teal:#0d9488;--teal-lt:#f0fdfa;
    --indigo:#4f46e5;--indigo-lt:#eef2ff;
    --radius:14px;--radius-sm:8px;
    --shadow:0 1px 3px rgba(0,0,0,.06),0 1px 2px rgba(0,0,0,.04);
    --shadow-md:0 4px 20px rgba(0,0,0,.09),0 1px 4px rgba(0,0,0,.04);
    --shadow-lg:0 12px 40px rgba(0,0,0,.12),0 2px 8px rgba(0,0,0,.06);
    --font:'DM Sans',sans-serif;--mono:'DM Mono',monospace;
  }
  *{box-sizing:border-box;margin:0;padding:0;}
  .fin{background:var(--bg);min-height:100vh;font-family:var(--font);color:var(--text);padding-bottom:80px;}
  .fin-header{background:var(--surface);border-bottom:1px solid var(--border);padding:0 40px;position:sticky;top:0;z-index:50;}
  .fin-header-inner{max-width:1600px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;height:68px;gap:20px;flex-wrap:wrap;}
  .fin-logo{display:flex;align-items:center;gap:10px;}
  .fin-logo-dot{width:28px;height:28px;background:var(--blue);border-radius:8px;display:flex;align-items:center;justify-content:center;color:#fff;font-size:14px;font-weight:700;}
  .fin-page-title{font-size:17px;font-weight:700;letter-spacing:-.03em;}
  .fin-page-title span{color:var(--muted);font-weight:400;margin:0 5px;}
  .fin-controls{display:flex;gap:8px;align-items:center;flex-wrap:wrap;}
  .fin-label-inline{font-size:11px;font-weight:600;color:var(--muted);text-transform:uppercase;letter-spacing:.05em;}
  .fin-input{height:36px;padding:0 12px;border:1px solid var(--border2);border-radius:var(--radius-sm);font-family:var(--mono);font-size:12px;color:var(--text);background:var(--surface);outline:none;transition:border .15s,box-shadow .15s;}
  .fin-input:focus{border-color:var(--blue);box-shadow:0 0 0 3px rgba(37,99,235,.1);}
  .fin-btn-primary{height:36px;padding:0 18px;background:var(--blue);color:#fff;border:none;border-radius:var(--radius-sm);font-family:var(--font);font-size:13px;font-weight:600;cursor:pointer;transition:background .15s,transform .1s;white-space:nowrap;display:inline-flex;align-items:center;gap:6px;}
  .fin-btn-primary:hover{background:var(--blue-dk);transform:translateY(-1px);}
  .fin-btn-ghost{height:34px;padding:0 14px;background:var(--surface);color:var(--sub);border:1px solid var(--border2);border-radius:var(--radius-sm);font-family:var(--font);font-size:12px;font-weight:500;cursor:pointer;transition:all .15s;display:inline-flex;align-items:center;gap:6px;white-space:nowrap;}
  .fin-btn-ghost:hover{border-color:var(--blue);color:var(--blue);background:var(--blue-lt);}
  .fin-btn-ghost:disabled{opacity:.4;cursor:not-allowed;pointer-events:none;}
  .fin-body{max-width:1600px;margin:0 auto;padding:28px 40px 0;}
  @media(max-width:768px){.fin-body{padding:16px;}.fin-header{padding:0 16px;}}
  .fin-tabs{display:flex;gap:2px;padding:4px;background:var(--surface2);border:1px solid var(--border);border-radius:12px;margin-bottom:28px;width:fit-content;}
  .fin-tab{height:34px;padding:0 16px;border-radius:9px;border:none;background:transparent;font-family:var(--font);font-size:13px;font-weight:500;color:var(--sub);cursor:pointer;transition:all .15s;display:inline-flex;align-items:center;gap:7px;}
  .fin-tab:hover{color:var(--text);background:var(--border);}
  .fin-tab.active{background:var(--surface);color:var(--blue);font-weight:700;box-shadow:var(--shadow);}
  .fin-section-label{font-size:10.5px;font-weight:700;text-transform:uppercase;letter-spacing:.1em;color:var(--muted);margin-bottom:14px;display:flex;align-items:center;gap:10px;}
  .fin-section-label::after{content:'';flex:1;height:1px;background:var(--border);}
  .fin-kpi-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(185px,1fr));gap:12px;margin-bottom:28px;}
  .fin-kpi{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);padding:20px;display:flex;flex-direction:column;gap:16px;box-shadow:var(--shadow);transition:all .2s;cursor:default;position:relative;overflow:hidden;}
  .fin-kpi::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:var(--accent,var(--blue));opacity:0;transition:opacity .2s;}
  .fin-kpi:hover{box-shadow:var(--shadow-md);transform:translateY(-2px);}
  .fin-kpi:hover::before{opacity:1;}
  .fin-kpi-top{display:flex;align-items:flex-start;justify-content:space-between;}
  .fin-kpi-icon{width:34px;height:34px;border-radius:9px;display:flex;align-items:center;justify-content:center;font-size:14px;flex-shrink:0;}
  .fin-kpi-label{font-size:11.5px;font-weight:500;color:var(--sub);line-height:1.35;}
  .fin-kpi-value{font-family:var(--mono);font-size:20px;font-weight:500;letter-spacing:-.03em;line-height:1;}
  .fin-kpi-value.blue{color:var(--blue);}.fin-kpi-value.green{color:var(--green);}.fin-kpi-value.red{color:var(--red);}.fin-kpi-value.amber{color:var(--amber);}.fin-kpi-value.purple{color:var(--purple);}.fin-kpi-value.orange{color:var(--orange);}.fin-kpi-value.teal{color:var(--teal);}
  .fin-kpi-delta{display:inline-flex;align-items:center;gap:3px;font-size:11px;font-weight:600;padding:2px 6px;border-radius:20px;margin-top:5px;}
  .fin-kpi-delta.up{background:var(--green-lt);color:var(--green);}.fin-kpi-delta.down{background:var(--red-lt);color:var(--red);}.fin-kpi-delta.neutral{background:var(--bg);color:var(--muted);}
  .fin-kpi-badge{display:inline-block;margin-top:5px;padding:2px 7px;border-radius:20px;font-size:10px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;background:var(--orange-lt);color:var(--orange);border:1px solid rgba(234,88,12,.18);}
  .fin-card{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);box-shadow:var(--shadow);overflow:hidden;margin-bottom:20px;}
  .fin-card-header{padding:16px 22px;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;}
  .fin-card-title{font-size:14px;font-weight:700;letter-spacing:-.01em;display:flex;align-items:center;gap:7px;}
  .fin-card-sub{font-size:12px;color:var(--muted);font-weight:400;margin-left:4px;}

  /* ── Tabela responsiva ── */
  .fin-table-wrap{overflow-x:auto;width:100%;-webkit-overflow-scrolling:touch;}
  table.fin-table{width:100%;border-collapse:collapse;font-size:12px;table-layout:auto;}
  .fin-table thead th{
    padding:9px 8px;text-align:left;font-size:9.5px;font-weight:700;
    letter-spacing:.06em;text-transform:uppercase;color:var(--muted);
    background:var(--surface2);border-bottom:1px solid var(--border);
    white-space:nowrap;position:sticky;top:0;z-index:2;
  }
  .fin-table thead th.col-custo{color:var(--orange);}
  .fin-table thead th.right{text-align:right;}
  .fin-table thead th.center{text-align:center;}
  .fin-table tbody tr{border-bottom:1px solid var(--border);transition:background .1s;}
  .fin-table tbody tr:last-child{border-bottom:none;}
  .fin-table tbody tr:hover{background:var(--surface2);}
  .fin-table tbody tr.top-row{background:var(--blue-lt);}
  .fin-table tbody tr.top-row:hover{background:var(--blue-mid);}
  .fin-table td{padding:10px 8px;vertical-align:middle;white-space:nowrap;}
  .fin-table td.mono{font-family:var(--mono);font-size:11.5px;}
  .fin-table td.right{text-align:right;}
  .fin-table td.center{text-align:center;}

  .rank{display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:6px;font-family:var(--mono);font-size:11px;font-weight:600;}
  .rank-1{background:#fef3c7;color:#92400e;}.rank-n{background:var(--bg);color:var(--muted);}
  .chip{display:inline-block;padding:2px 6px;border-radius:20px;font-size:9px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;vertical-align:middle;margin-left:5px;}
  .chip-blue{background:var(--blue-lt);color:var(--blue);}.chip-green{background:var(--green-lt);color:var(--green);}.chip-red{background:var(--red-lt);color:var(--red);}
  .pbar{display:flex;align-items:center;gap:5px;min-width:80px;}
  .pbar-track{width:40px;height:4px;background:#f0f1f5;border-radius:99px;overflow:hidden;flex-shrink:0;}
  .pbar-fill{height:100%;border-radius:99px;background:var(--blue);}
  .pbar-fill.red{background:var(--red);}
  .pbar-text{font-family:var(--mono);font-size:10px;color:var(--sub);white-space:nowrap;}
  .fin-check{appearance:none;width:15px;height:15px;border:1.5px solid var(--border2);border-radius:4px;cursor:pointer;transition:all .15s;position:relative;background:var(--surface);}
  .fin-check:checked{background:var(--blue);border-color:var(--blue);}
  .fin-check:checked::after{content:'';position:absolute;left:4px;top:1px;width:4px;height:8px;border:2px solid #fff;border-top:none;border-left:none;transform:rotate(40deg);}
  .fin-select{height:34px;padding:0 10px;border:1px solid var(--border2);border-radius:var(--radius-sm);font-family:var(--font);font-size:13px;color:var(--text);background:var(--surface);outline:none;transition:border .15s;cursor:pointer;}
  .fin-select:focus{border-color:var(--blue);}
  .fin-btn-sm{height:32px;padding:0 12px;background:var(--green-lt);color:var(--green);border:1px solid rgba(5,150,105,.25);border-radius:var(--radius-sm);font-size:12px;font-weight:600;cursor:pointer;font-family:var(--font);display:inline-flex;align-items:center;gap:5px;transition:background .15s;}
  .fin-btn-sm:hover{background:#d1fae5;}
  .subtotal-row{background:#f0fdf4!important;}.subtotal-row td{color:var(--green)!important;font-family:var(--mono);font-size:11px;font-weight:500;}
  .total-row{background:var(--blue-lt)!important;}.total-row td{color:var(--blue)!important;font-family:var(--mono);font-weight:700;font-size:12px;}
  .col-custo-cell{color:var(--orange);font-weight:600;}
  .fin-empty{display:flex;flex-direction:column;align-items:center;gap:10px;padding:52px 24px;color:var(--muted);font-size:13px;}
  .fin-spinner{width:24px;height:24px;border:2px solid var(--border);border-top-color:var(--blue);border-radius:50%;animation:spin .7s linear infinite;}
  @keyframes spin{to{transform:rotate(360deg);}}
  .fin-kpi-split{display:flex;flex-direction:column;gap:6px;margin-top:4px;}
  .fin-kpi-split-bar{height:6px;border-radius:99px;overflow:hidden;background:#f0f1f5;display:flex;}
  .fin-kpi-split-seg-a{height:100%;background:var(--teal);transition:width .5s ease;}
  .fin-kpi-split-seg-b{height:100%;background:#e4e7ef;flex:1;}
  .fin-kpi-split-labels{display:flex;justify-content:space-between;}
  .fin-kpi-split-lbl{font-size:10px;color:var(--muted);font-family:var(--mono);}
  .fin-kpi-split-lbl.hi{color:var(--teal);font-weight:600;}
  .range-card-body{padding:20px 24px;display:flex;align-items:center;gap:28px;flex-wrap:wrap;}
  .range-svg-wrap{flex-shrink:0;position:relative;width:120px;height:120px;}
  .range-svg-label{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;pointer-events:none;}
  .range-svg-pct{font-family:var(--mono);font-size:22px;font-weight:500;color:var(--teal);line-height:1;}
  .range-svg-sub{font-size:10px;color:var(--muted);margin-top:2px;}
  .range-legend{display:flex;flex-direction:column;gap:12px;flex:1;min-width:160px;}
  .range-legend-row{display:flex;align-items:center;gap:10px;}
  .range-legend-dot{width:10px;height:10px;border-radius:50%;flex-shrink:0;}
  .range-legend-lbl{font-size:12px;color:var(--sub);flex:1;}
  .range-legend-val{font-family:var(--mono);font-size:13px;font-weight:600;}
  .range-legend-pct{font-family:var(--mono);font-size:11px;color:var(--muted);}
  .bi-2col{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:20px;}
  .bi-3col{display:grid;grid-template-columns:1fr 1fr 1fr;gap:16px;margin-bottom:20px;}
  @media(max-width:1100px){.bi-3col{grid-template-columns:1fr 1fr;}}
  @media(max-width:900px){.bi-2col,.bi-3col{grid-template-columns:1fr;}}
  .bi-chart-body{padding:16px 20px 20px;}
  .bi-chart-canvas{position:relative;height:240px;}
  .bi-chart-canvas.tall{height:300px;}
  .bi-insights{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:12px;margin-bottom:20px;}
  .bi-insight{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);padding:18px 20px;box-shadow:var(--shadow);display:flex;flex-direction:column;gap:10px;}
  .bi-insight-title{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:var(--muted);}
  .bi-insight-value{font-family:var(--mono);font-size:22px;font-weight:500;letter-spacing:-.03em;}
  .bi-insight-desc{font-size:12px;color:var(--sub);line-height:1.5;}
  .bi-insight-accent{width:32px;height:3px;border-radius:99px;background:var(--accent,var(--blue));}
  .heat-high{background:rgba(5,150,105,.12)!important;}.heat-low{background:rgba(220,38,38,.07)!important;}
  .bi-filter-chip{height:28px;padding:0 12px;border:1px solid var(--border2);border-radius:99px;font-size:12px;font-weight:500;color:var(--sub);background:var(--surface);cursor:pointer;transition:all .15s;white-space:nowrap;}
  .bi-filter-chip:hover,.bi-filter-chip.active{border-color:var(--blue);color:var(--blue);background:var(--blue-lt);font-weight:700;}
  .bi-funnel{display:flex;flex-direction:column;gap:8px;padding:16px 20px;}
  .bi-funnel-row{display:flex;align-items:center;gap:12px;}
  .bi-funnel-label{font-size:12px;font-weight:500;color:var(--sub);width:140px;flex-shrink:0;}
  .bi-funnel-bar-track{flex:1;height:18px;background:var(--bg);border-radius:6px;overflow:hidden;}
  .bi-funnel-bar-fill{height:100%;border-radius:6px;display:flex;align-items:center;padding-left:10px;transition:width .6s ease;}
  .bi-funnel-bar-text{font-family:var(--mono);font-size:11px;font-weight:500;color:#fff;white-space:nowrap;}
  .bi-funnel-pct{font-family:var(--mono);font-size:11px;color:var(--sub);width:42px;text-align:right;flex-shrink:0;}
  .bi-matrix{display:grid;grid-template-columns:1fr 1fr;grid-template-rows:1fr 1fr;gap:2px;background:var(--border);border-radius:var(--radius);overflow:hidden;}
  .bi-quadrant{background:var(--surface);padding:16px;display:flex;flex-direction:column;gap:6px;min-height:120px;}
  .bi-quadrant-label{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;}
  .bi-quadrant-items{display:flex;flex-direction:column;gap:4px;}
  .bi-quadrant-item{font-size:12px;color:var(--sub);display:flex;align-items:center;gap:6px;}
  .bi-quadrant-dot{width:6px;height:6px;border-radius:50%;flex-shrink:0;}
  .abc-a{background:#ecfdf5;color:#059669;border:1px solid rgba(5,150,105,.25);}
  .abc-b{background:#eff4ff;color:#2563eb;border:1px solid rgba(37,99,235,.25);}
  .abc-c{background:#fff7ed;color:#ea580c;border:1px solid rgba(234,88,12,.25);}
  .abc-badge{display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:6px;font-size:11px;font-weight:800;letter-spacing:.02em;}
  .abc-summary{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:20px;}
  .abc-summary-card{border-radius:12px;padding:16px 20px;display:flex;flex-direction:column;gap:8px;}
  .abc-summary-label{font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.1em;}
  .abc-summary-value{font-family:var(--mono);font-size:24px;font-weight:500;line-height:1;}
  .abc-summary-sub{font-size:11px;opacity:.7;}
  @media(max-width:700px){.abc-summary{grid-template-columns:1fr;}}

  /* ── Tabela channels responsiva ── */
  .channels-table-container{width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;}
  .channels-table-container table{width:100%;min-width:900px;border-collapse:collapse;font-size:12px;}
  .channels-table-container thead th{
    padding:9px 10px;font-size:9px;font-weight:700;letter-spacing:.07em;
    text-transform:uppercase;color:var(--muted);background:var(--surface2);
    border-bottom:1px solid var(--border);white-space:nowrap;text-align:left;
  }
  .channels-table-container thead th.r{text-align:right;}
  .channels-table-container thead th.c{text-align:center;}
  .channels-table-container thead th.col-custo{color:var(--orange);}
  .channels-table-container tbody tr{border-bottom:1px solid var(--border);transition:background .1s;}
  .channels-table-container tbody tr:hover{background:var(--surface2);}
  .channels-table-container tbody tr.top-row{background:var(--blue-lt);}
  .channels-table-container tbody tr.top-row:hover{background:var(--blue-mid);}
  .channels-table-container tbody tr.heat-high{background:rgba(5,150,105,.12)!important;}
  .channels-table-container tbody tr.heat-low{background:rgba(220,38,38,.07)!important;}
  .channels-table-container td{padding:10px 10px;vertical-align:middle;white-space:nowrap;}
  .channels-table-container td.mono{font-family:var(--mono);font-size:11px;}
  .channels-table-container td.r{text-align:right;}
  .channels-table-container td.c{text-align:center;}
  .channels-table-container tr.total-row{background:var(--blue-lt)!important;}
  .channels-table-container tr.total-row td{color:var(--blue)!important;font-family:var(--mono);font-weight:700;font-size:11.5px;}
`

const fmt    = (n) => n?.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) ?? '—'
const fmtBRL = (n) => `R$ ${fmt(n)}`
const fmtPct = (n) => (n != null ? `${n.toFixed(1)}%` : '—')
function pct(part, total) { return total ? (part / total) * 100 : 0 }

const CHART_DEFAULTS = {
  responsive: true, maintainAspectRatio: false,
  plugins: { legend: { labels: { color: '#8c94a6', font: { family: 'DM Mono', size: 10 }, boxWidth: 8, padding: 14 } } },
  scales: {
    x: { ticks: { color: '#8c94a6', font: { family: 'DM Mono', size: 9 } }, grid: { color: '#eef0f5' } },
    y: { ticks: { color: '#8c94a6', font: { family: 'DM Mono', size: 9 } }, grid: { color: '#eef0f5' } },
  },
}
const PIE_DEFAULTS = {
  responsive: true, maintainAspectRatio: false,
  plugins: { legend: { position: 'right', labels: { color: '#5b6578', font: { family: 'DM Mono', size: 10 }, boxWidth: 10, padding: 12 } } },
}
const PALETTE = ['#2563eb','#059669','#7c3aed','#d97706','#ea580c','#0d9488','#dc2626','#4f46e5','#db2777','#0369a1']

function KpiCard({ icon, iconBg, iconColor, label, value, valueClass, badge, delta, accentColor }) {
  return (
    <div className="fin-kpi" style={{ '--accent': accentColor || 'var(--blue)' }}>
      <div className="fin-kpi-top">
        <div className="fin-kpi-label">{label}</div>
        <div className="fin-kpi-icon" style={{ background: iconBg, color: iconColor }}>{icon}</div>
      </div>
      <div>
        <div className={`fin-kpi-value ${valueClass || ''}`}>{value}</div>
        {delta != null && (
          <div className={`fin-kpi-delta ${delta > 0 ? 'up' : delta < 0 ? 'down' : 'neutral'}`}>
            {delta > 0 ? <FaArrowUp size={8} /> : delta < 0 ? <FaArrowDown size={8} /> : null}
            {delta > 0 ? '+' : ''}{delta?.toFixed(1)}%
          </div>
        )}
        {badge && <div className="fin-kpi-badge">{badge}</div>}
      </div>
    </div>
  )
}

function InsightCard({ title, value, desc, accent }) {
  return (
    <div className="bi-insight">
      <div className="bi-insight-accent" style={{ background: accent || 'var(--blue)' }} />
      <div className="bi-insight-title">{title}</div>
      <div className="bi-insight-value" style={{ color: accent || 'var(--blue)' }}>{value}</div>
      <div className="bi-insight-desc">{desc}</div>
    </div>
  )
}

function Financial() {
  const [tab, setTab] = useState('overview')
  const [marketplaceData, setMarketplaceData] = useState([])
  const [selectedAccounts, setSelectedAccounts] = useState([])
  const [loading, setLoading] = useState(false)
  const [startDate, setStartDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'))
  const [endDate, setEndDate]     = useState(dayjs().format('YYYY-MM-DD'))
  const [summary, setSummary] = useState({
    totalGrossRevenue: 0, totalNetRevenue: 0, totalOrders: 0,
    totalCanceledValue: 0, totalFreightValue: 0, totalCustoFrete: 0,
    totalParts: 0, totalQtdRange: 0,
  })
  const [responseData, setResponseData] = useState([])
  const [categoriaSelecionada, setCategoriaSelecionada] = useState('Todas')
  const [sortBy, setSortBy]   = useState('faturamento_liquido')
  const [abcFiltro, setAbcFiltro] = useState('Todas')

  const toggleSelection = (ap) =>
    setSelectedAccounts(p => p.includes(ap) ? p.filter(x => x !== ap) : [...p, ap])

  const categorias = ['Todas', ...new Set(responseData.map(i => i.categoria))]

  const dadosFiltrados = useMemo(() =>
    categoriaSelecionada === 'Todas' ? responseData : responseData.filter(i => i.categoria === categoriaSelecionada),
    [categoriaSelecionada, responseData])

  const groupedData = useMemo(() =>
    dadosFiltrados.reduce((acc, item) => {
      if (!acc[item.apelido]) acc[item.apelido] = { total: 0, items: [] }
      acc[item.apelido].items.push(item)
      acc[item.apelido].total += item.valor_novo
      return acc
    }, {}), [dadosFiltrados])

  const skuData = useMemo(() => {
    const map = {}
    dadosFiltrados.forEach(item => {
      const key = (item.sku || '') + '||' + (item.descricao || '')
      if (!map[key]) {
        map[key] = { sku: item.sku || '—', descricao: item.descricao || item.sku || '—', categoria: item.categoria || '—', quantidade: 0, valor: 0, contas: new Set() }
      }
      map[key].quantidade += Number(item.quantidade_nova || 0)
      map[key].valor      += Number(item.valor_novo || 0)
      map[key].contas.add(item.apelido)
    })
    return Object.values(map).map(i => ({ ...i, contas: i.contas.size })).sort((a, b) => b.valor - a.valor)
  }, [dadosFiltrados])

  const abcData = useMemo(() => {
    const total = skuData.reduce((s, i) => s + i.valor, 0)
    let acumulado = 0
    return skuData.map((item, idx) => {
      acumulado += item.valor
      const pctAcum = total ? (acumulado / total) * 100 : 0
      const classe = pctAcum <= 80 ? 'A' : pctAcum <= 95 ? 'B' : 'C'
      return { ...item, idx: idx + 1, pctIndividual: total ? (item.valor / total) * 100 : 0, pctAcumulado: pctAcum, classe }
    })
  }, [skuData])

  const abcDataFiltrado = useMemo(() =>
    abcFiltro === 'Todas' ? abcData : abcData.filter(i => i.classe === abcFiltro),
    [abcData, abcFiltro])

  const abcResumo = useMemo(() => {
    const a = abcData.filter(i => i.classe === 'A')
    const b = abcData.filter(i => i.classe === 'B')
    const c = abcData.filter(i => i.classe === 'C')
    return {
      A: { qtdSkus: a.length, valor: a.reduce((s,i)=>s+i.valor,0), pctSkus: abcData.length ? (a.length/abcData.length)*100 : 0 },
      B: { qtdSkus: b.length, valor: b.reduce((s,i)=>s+i.valor,0), pctSkus: abcData.length ? (b.length/abcData.length)*100 : 0 },
      C: { qtdSkus: c.length, valor: c.reduce((s,i)=>s+i.valor,0), pctSkus: abcData.length ? (c.length/abcData.length)*100 : 0 },
    }
  }, [abcData])

  const paretoChartData = useMemo(() => {
    const top = abcData.slice(0, 25)
    return {
      labels: top.map(i => i.sku.length > 14 ? i.sku.slice(0,14)+'…' : i.sku),
      datasets: [
        { type: 'bar', label: 'Faturamento (R$)', data: top.map(i => i.valor), backgroundColor: top.map(i => i.classe==='A'?'rgba(5,150,105,.8)':i.classe==='B'?'rgba(37,99,235,.7)':'rgba(234,88,12,.65)'), borderRadius: 5, borderSkipped: false, yAxisID: 'y', order: 2 },
        { type: 'line', label: '% Acumulado', data: top.map(i => i.pctAcumulado), borderColor: '#7c3aed', backgroundColor: 'rgba(124,58,237,.06)', fill: true, tension: 0.35, pointBackgroundColor: top.map(i => i.pctAcumulado<=80?'#059669':i.pctAcumulado<=95?'#2563eb':'#ea580c'), pointRadius: 4, pointBorderColor: '#fff', pointBorderWidth: 1.5, yAxisID: 'y2', order: 1 },
      ],
    }
  }, [abcData])

  const paretoOptions = useMemo(() => ({
    responsive: true, maintainAspectRatio: false,
    plugins: { legend: { labels: { color: '#8c94a6', font: { family: 'DM Mono', size: 10 }, boxWidth: 10, padding: 14 } } },
    scales: {
      x: { ticks: { color: '#8c94a6', font: { family: 'DM Mono', size: 8 }, maxRotation: 45 }, grid: { color: '#eef0f5' } },
      y: { position: 'left', ticks: { color: '#8c94a6', font: { family: 'DM Mono', size: 9 }, callback: v => 'R$ ' + v.toLocaleString('pt-BR') }, grid: { color: '#eef0f5' } },
      y2: { position: 'right', min: 0, max: 100, ticks: { color: '#7c3aed', font: { family: 'DM Mono', size: 9 }, callback: v => v + '%' }, grid: { drawOnChartArea: false } },
    },
  }), [abcData])

  const totalVendas = useMemo(() => dadosFiltrados.reduce((s, i) => s + i.valor_novo, 0), [dadosFiltrados])
  const sortedData  = useMemo(() => [...marketplaceData].sort((a, b) => b[sortBy] - a[sortBy]), [marketplaceData, sortBy])

  const biData = useMemo(() => {
    if (!marketplaceData.length) return null
    const top    = [...marketplaceData].sort((a, b) => b.faturamento_liquido - a.faturamento_liquido)
    const topCan = [...marketplaceData].sort((a, b) => b.percentual_cancelado - a.percentual_cancelado)[0]
    const topFull= [...marketplaceData].sort((a, b) => b.percentual_fullfilment - a.percentual_fullfilment)[0]
    const avgTk  = summary.totalOrders ? summary.totalGrossRevenue / summary.totalOrders : 0
    const taxaCan= summary.totalOrders ? (marketplaceData.reduce((s,i) => s + i.total_cancelado, 0) / (summary.totalOrders + marketplaceData.reduce((s,i) => s + i.total_cancelado, 0))) * 100 : 0
    const freteShare = summary.totalGrossRevenue ? (summary.totalFreightValue / summary.totalGrossRevenue) * 100 : 0
    const custoShare = summary.totalGrossRevenue ? (summary.totalCustoFrete / summary.totalGrossRevenue) * 100 : 0
    const partsShare = summary.totalGrossRevenue ? (summary.totalParts / summary.totalGrossRevenue) * 100 : 0
    return { top, topCh: top[0], topCan, topFull, avgTk, taxaCan, freteShare, custoShare, partsShare }
  }, [marketplaceData, summary])

  const barChartData = useMemo(() => ({
    labels: sortedData.map(i => i.apelido),
    datasets: [
      { label: 'Fat. Bruto',   data: sortedData.map(i => i.faturamento_bruto),   backgroundColor: 'rgba(37,99,235,.75)', borderRadius: 6, borderSkipped: false },
      { label: 'Fat. Líquido', data: sortedData.map(i => i.faturamento_liquido), backgroundColor: 'rgba(5,150,105,.65)', borderRadius: 6, borderSkipped: false },
    ],
  }), [sortedData])

  const doughnutData = useMemo(() => ({
    labels: sortedData.map(i => i.apelido),
    datasets: [{ data: sortedData.map(i => i.faturamento_liquido), backgroundColor: PALETTE, borderWidth: 0, hoverOffset: 6 }],
  }), [sortedData])

  const cancelChartData = useMemo(() => ({
    labels: marketplaceData.map(i => i.apelido),
    datasets: [{ label: 'Valor Cancelado', data: marketplaceData.map(i => i.valor_cancelado), borderColor: '#dc2626', backgroundColor: 'rgba(220,38,38,.07)', fill: true, tension: 0.4, pointBackgroundColor: '#dc2626', pointRadius: 4 }],
  }), [marketplaceData])

  const fullOrderChartData = useMemo(() => ({
    labels: marketplaceData.map(i => i.apelido),
    datasets: [{ label: 'Pedidos Full', data: marketplaceData.map(i => i.total_fullfilment), borderColor: '#2563eb', backgroundColor: 'rgba(37,99,235,.07)', fill: true, tension: 0.4, pointBackgroundColor: '#2563eb', pointRadius: 4 }],
  }), [marketplaceData])

  const freteComposicaoData = useMemo(() => ({
    labels: sortedData.map(i => i.apelido),
    datasets: [
      { label: 'Frete Real (>79)',    data: sortedData.map(i => i.frete_real || 0),       backgroundColor: 'rgba(13,148,136,.7)',  borderRadius: 4, borderSkipped: false },
      { label: 'Custo Frete (19–79)', data: sortedData.map(i => i.frete_paid_range || 0), backgroundColor: 'rgba(234,88,12,.7)',   borderRadius: 4, borderSkipped: false },
    ],
  }), [sortedData])

  const ticketMedioData = useMemo(() => ({
    labels: sortedData.map(i => i.apelido),
    datasets: [{ label: 'Ticket Médio (R$)', data: sortedData.map(i => i.ticket_medio || 0), borderColor: '#7c3aed', backgroundColor: 'rgba(124,58,237,.07)', fill: true, tension: 0.4, pointBackgroundColor: '#7c3aed', pointRadius: 5 }],
  }), [sortedData])

  const radarData = useMemo(() => {
    if (!marketplaceData.length) return null
    const maxFat =Math.max(...marketplaceData.map(i=>i.faturamento_bruto),1)
    const maxPed =Math.max(...marketplaceData.map(i=>i.total_pedidos),1)
    const maxFull=Math.max(...marketplaceData.map(i=>i.total_fullfilment),1)
    const maxTk  =Math.max(...marketplaceData.map(i=>i.ticket_medio||0),1)
    return {
      labels: ['Fat. Bruto','Total Pedidos','Fullfilment','Ticket Médio','Fat. Líquido'],
      datasets: marketplaceData.slice(0,5).map((item,idx)=>({
        label: item.apelido,
        data: [(item.faturamento_bruto/maxFat)*100,(item.total_pedidos/maxPed)*100,(item.total_fullfilment/maxFull)*100,((item.ticket_medio||0)/maxTk)*100,(item.faturamento_liquido/maxFat)*100],
        borderColor: PALETTE[idx], backgroundColor: PALETTE[idx]+'22', pointBackgroundColor: PALETTE[idx], pointRadius: 3,
      })),
    }
  }, [marketplaceData])

  const quadrants = useMemo(() => {
    if (!marketplaceData.length) return { highHigh:[], highLow:[], lowHigh:[], lowLow:[] }
    const medFat = marketplaceData.reduce((s,i)=>s+i.faturamento_liquido,0)/marketplaceData.length
    const medCan = marketplaceData.reduce((s,i)=>s+(i.percentual_cancelado||0),0)/marketplaceData.length
    return marketplaceData.reduce((q,i)=>{
      const highFat=i.faturamento_liquido>=medFat, highCan=(i.percentual_cancelado||0)>=medCan
      if(highFat&&!highCan) q.highHigh.push(i)
      else if(highFat&&highCan) q.highLow.push(i)
      else if(!highFat&&!highCan) q.lowHigh.push(i)
      else q.lowLow.push(i)
      return q
    },{ highHigh:[],highLow:[],lowHigh:[],lowLow:[] })
  }, [marketplaceData])

  const fetchData = async (start = startDate, end = endDate) => {
    setLoading(true)
    const d1 = dayjs(start).format('DD.MM.YYYY')
    const d2 = dayjs(end).format('DD.MM.YYYY')
    try {
      const r = await apinode.get(`relatorio/categoria/${localStorage.idconta}`, { params: { data1: d1, data2: d2 } })
      setResponseData(r.data)
    } catch (e) { console.error(e) }
    try {
      const r = await apinode.get(`faturamento/${localStorage.idconta}?data1=${d1}&data2=${d2}`)
      const data = r.data.map(i => {
        const freteReal  = i.valor_frete      || 0
        const custoFrete = i.frete_paid_range  || 0
        const fatLiquido = i.faturamento_bruto - freteReal - custoFrete
        return { ...i, frete_real: freteReal, faturamento_liquido: fatLiquido, ticket_medio: i.faturamento_bruto / (i.total_pedidos || 1) }
      })
      setMarketplaceData([...data].sort((a, b) => b.faturamento_liquido - a.faturamento_liquido))
      setSummary({
        totalGrossRevenue:  data.reduce((s,i) => s + i.faturamento_bruto,       0),
        totalNetRevenue:    data.reduce((s,i) => s + i.faturamento_liquido,      0),
        totalOrders:        data.reduce((s,i) => s + i.total_pedidos,            0),
        totalCanceledValue: data.reduce((s,i) => s + i.valor_cancelado,          0),
        totalFreightValue:  data.reduce((s,i) => s + i.frete_real,               0),
        totalCustoFrete:    data.reduce((s,i) => s + (i.frete_paid_range || 0),  0),
        totalParts:         data.reduce((s,i) => s + (i.valor_parts     || 0),   0),
        totalQtdRange:      data.reduce((s,i) => s + (i.qtd_pedidos_range || 0), 0),
      })
    } catch (e) { console.error(e) }
    finally { setLoading(false) }
  }

  useEffect(() => {
    const isAdmin = localStorage.getItem('admin')
    if (isAdmin !== 'SIM') {
      toast.error('Você não tem permissão!', { position: 'top-center', autoClose: 2000 })
      setTimeout(() => { window.location.href = '/' }, 2000)
      return
    }
    fetchData()
  }, [])

  const showProjection = dayjs(startDate).isSame(dayjs().startOf('month'),'day') && dayjs(endDate).isSameOrBefore(dayjs().endOf('month'),'day')
  const projected = showProjection ? (summary.totalNetRevenue / dayjs().date()) * dayjs().daysInMonth() : null

  const funnelRows = useMemo(() => {
    const totalBruto = summary.totalGrossRevenue || 1
    return [
      { label: 'Fat. Bruto',           value: summary.totalGrossRevenue,                             color: '#2563eb' },
      { label: 'Frete Real (>79)',      value: summary.totalGrossRevenue - summary.totalFreightValue, color: '#0d9488' },
      { label: 'Custo Frete (19–79)',   value: summary.totalGrossRevenue - summary.totalCustoFrete,   color: '#ea580c' },
      { label: 'Fat. Líquido',          value: summary.totalNetRevenue,                               color: '#059669' },
    ].map(r => ({ ...r, pct: pct(r.value, totalBruto) }))
  }, [summary])

  const gerarPDF = () => {
    const sorted = [...dadosFiltrados].sort((a,b)=>new Date(b.data)-new Date(a.data))
    const gd = sorted.reduce((acc,item)=>{ if(!acc[item.apelido]) acc[item.apelido]={total:0,items:[]}; acc[item.apelido].items.push(item); acc[item.apelido].total+=item.valor_novo; return acc },{})
    pdfMake.createPdf({
      pageOrientation:'landscape',pageSize:'A4',pageMargins:[20,20,20,20],
      content:[
        {text:'Relatório de Vendas',style:'header'},
        ...Object.entries(gd).flatMap(([ap,g])=>[
          {text:`Conta: ${ap}`,style:'subheader'},
          {table:{headerRows:1,widths:[50,40,'*',40,40,50,50],body:[
            ['Conta','SKU','Descrição','V. Unitário','Qtd','Total','Data'].map(t=>({text:t,bold:true,fontSize:8})),
            ...g.items.map(item=>[item.apelido,item.sku,item.descricao,`R$ ${item?.valorunitario?.toFixed(2)}`,item?.quantidade_nova?.toFixed(2),`R$ ${item?.valor_novo?.toFixed(2)}`,new Date(item?.data)?.toLocaleDateString('pt-BR')].map((t,i)=>({text:t,fontSize:6,alignment:i>=3?'right':'left'}))),
            [{text:'Subtotal',colSpan:5,alignment:'right',bold:true,fontSize:7},'','','','',{text:`R$ ${g?.total?.toFixed(2)}`,bold:true,fontSize:7,alignment:'right'},''],
          ]},layout:'lightHorizontalLines',margin:[0,3,0,10]},
        ]),
        {text:`Total Geral: R$ ${sorted.reduce((a,i)=>a+i.valor_novo,0)?.toFixed(2)}`,style:'total'},
      ],
      styles:{header:{fontSize:12,bold:true,margin:[0,0,0,5]},subheader:{fontSize:8,bold:true,margin:[0,5,0,2]},total:{fontSize:10,bold:true,margin:[0,10,0,0],color:'blue'}},
    }).open()
  }

  const generatePDF = () => {
    const fd = marketplaceData.filter(i=>selectedAccounts.includes(i.apelido))
    if(!fd.length) return
    const tFB=fd.reduce((s,i)=>s+i.faturamento_bruto,0)
    const tFL=fd.reduce((s,i)=>s+i.faturamento_liquido,0)
    const tFR=fd.reduce((s,i)=>s+i.frete_real,0)
    const tCF=fd.reduce((s,i)=>s+(i.frete_paid_range||0),0)
    const tC=fd.reduce((s,i)=>s+i.total_cancelado,0)
    const tP=fd.reduce((s,i)=>s+i.total_pedidos,0)
    pdfMake.createPdf({
      content:[
        {text:'Relatório de Faturamento por Marketplace',style:'header'},
        {text:`Período: ${dayjs(startDate).format('DD/MM/YYYY')} - ${dayjs(endDate).format('DD/MM/YYYY')}`,style:'subheader',margin:[0,5,0,10]},
        {table:{headerRows:1,widths:['auto','auto','auto','auto','auto','auto','auto'],body:[
          ['Marketplace','Fat. Bruto','Frete Real (>79)','Custo Frete (19–79)','Fat. Líquido','Cancelados','Pedidos'].map(t=>({text:t,style:'tableHeader'})),
          ...fd.map(item=>[item.apelido,fmtBRL(item.faturamento_bruto),fmtBRL(item.frete_real),fmtBRL(item.frete_paid_range||0),fmtBRL(item.faturamento_liquido),item.total_cancelado,item.total_pedidos].map(t=>({text:String(t),style:'tableCell'}))),
          ['Subtotal',fmtBRL(tFB),fmtBRL(tFR),fmtBRL(tCF),fmtBRL(tFL),tC,tP].map(t=>({text:String(t),style:'tableHeader'})),
        ]},layout:'lightHorizontalLines'},
      ],
      styles:{header:{fontSize:16,bold:true,alignment:'center',marginBottom:10},subheader:{fontSize:11,alignment:'center',italics:true},tableHeader:{bold:true,fontSize:10,fillColor:'#f3f3f3',alignment:'center'},tableCell:{fontSize:9,margin:[3,3,3,3],alignment:'center'}},
    }).open()
  }

  return (
    <>
      <style>{css}</style>
      <Navbar />

      <div className="fin-header">
        <div className="fin-header-inner">
          <div className="fin-logo">
            <div className="fin-logo-dot">Z</div>
            <div className="fin-page-title">Financeiro <span>/</span> Dashboard</div>
          </div>
          <div className="fin-controls">
            <span className="fin-label-inline">De</span>
            <input type="date" className="fin-input" value={startDate} onChange={e=>setStartDate(e.target.value)} />
            <span className="fin-label-inline">Até</span>
            <input type="date" className="fin-input" value={endDate} onChange={e=>setEndDate(e.target.value)} />
            <button className="fin-btn-primary" onClick={()=>fetchData(startDate,endDate)} disabled={loading}>
              {loading ? <><div className="fin-spinner" style={{width:14,height:14,borderWidth:2,borderTopColor:'#fff',borderColor:'rgba(255,255,255,.3)'}}/> Pesquisando...</> : <><BsGraphUp size={12}/> Pesquisar</>}
            </button>
          </div>
        </div>
      </div>

      <div className="fin">
        <div className="fin-body">
          <div className="fin-tabs">
            <button className={`fin-tab ${tab==='overview'?'active':''}`} onClick={()=>setTab('overview')}><FaChartLine size={12}/> Visão Geral</button>
            <button className={`fin-tab ${tab==='bi'?'active':''}`} onClick={()=>setTab('bi')}><MdOutlineAutoGraph size={13}/> BI & Análise</button>
            <button className={`fin-tab ${tab==='channels'?'active':''}`} onClick={()=>setTab('channels')}><FaChartBar size={12}/> Por Canal</button>
            <button className={`fin-tab ${tab==='sku'?'active':''}`} onClick={()=>setTab('sku')}><BsTable size={12}/> SKU / Curva ABC</button>
          </div>

          {/* ════════ OVERVIEW ════════ */}
          {tab === 'overview' && (
            <>
              <div className="fin-section-label">Resumo do período</div>
              <div className="fin-kpi-grid">
                <KpiCard icon={<FaDollarSign/>} iconBg="#eff4ff" iconColor="#2563eb" label="Faturamento Bruto"      value={fmtBRL(summary.totalGrossRevenue)}  valueClass="blue"   accentColor="var(--blue)"/>
                <KpiCard icon={<FaChartLine/>}  iconBg="#ecfdf5" iconColor="#059669" label="Faturamento Líquido"    value={fmtBRL(summary.totalNetRevenue)}    valueClass="green"  accentColor="var(--green)"/>
                <KpiCard icon={<FaBox/>}         iconBg="#f5f3ff" iconColor="#7c3aed" label="Total de Pedidos"       value={summary.totalOrders.toLocaleString('pt-BR')} valueClass="purple" accentColor="var(--purple)"/>
                <KpiCard icon={<FaTruck/>}       iconBg="#fffbeb" iconColor="#d97706" label="Frete Real (>R$79)"     value={fmtBRL(summary.totalFreightValue)}  valueClass="amber"  accentColor="var(--amber)"/>
                <KpiCard icon={<FaShoppingCart/>} iconBg="#fff7ed" iconColor="#ea580c" label="Custo Frete (R$19–79)" value={fmtBRL(summary.totalCustoFrete)}    valueClass="orange" badge="paid 19–79" accentColor="var(--orange)"/>
                <KpiCard icon={<FaArrowDown/>}  iconBg="#fef2f2" iconColor="#dc2626" label="Valor Cancelado"        value={fmtBRL(summary.totalCanceledValue)} valueClass="red"    accentColor="var(--red)"/>
                <div className="fin-kpi" style={{'--accent':'var(--teal)'}}>
                  <div className="fin-kpi-top">
                    <div className="fin-kpi-label">Pedidos R$19–79</div>
                    <div className="fin-kpi-icon" style={{background:'#f0fdfa',color:'#0d9488'}}><FaFilter/></div>
                  </div>
                  <div>
                    <div className="fin-kpi-value teal">{summary.totalQtdRange.toLocaleString('pt-BR')}</div>
                    <div className="fin-kpi-split">
                      <div className="fin-kpi-split-bar">
                        <div className="fin-kpi-split-seg-a" style={{width:`${pct(summary.totalQtdRange,summary.totalOrders||1)}%`}}/>
                        <div className="fin-kpi-split-seg-b"/>
                      </div>
                      <div className="fin-kpi-split-labels">
                        <span className="fin-kpi-split-lbl hi">{fmtPct(pct(summary.totalQtdRange,summary.totalOrders||1))} range</span>
                        <span className="fin-kpi-split-lbl">{(summary.totalOrders-summary.totalQtdRange).toLocaleString('pt-BR')} demais</span>
                      </div>
                    </div>
                  </div>
                </div>
                <KpiCard icon={<FaBox/>} iconBg="#eef2ff" iconColor="#4f46e5" label="Fat. Parts (Cat.50)" value={fmtBRL(summary.totalParts)} valueClass="purple" accentColor="var(--indigo)"/>
                {showProjection && <KpiCard icon={<FaTrophy/>} iconBg="#eff4ff" iconColor="#2563eb" label="Projeção do Mês" value={fmtBRL(projected)} valueClass="blue" accentColor="var(--blue)"/>}
              </div>
              <div className="bi-2col">
                <div className="fin-card"><div className="fin-card-header"><span className="fin-card-title"><FaChartBar size={13}/> Bruto vs Líquido por Canal</span></div><div className="bi-chart-body"><div className="bi-chart-canvas"><Bar data={barChartData} options={CHART_DEFAULTS}/></div></div></div>
                <div className="fin-card"><div className="fin-card-header"><span className="fin-card-title"><FaChartPie size={13}/> Share Líquido por Canal</span></div><div className="bi-chart-body"><div className="bi-chart-canvas"><Doughnut data={doughnutData} options={PIE_DEFAULTS}/></div></div></div>
              </div>
              <div className="bi-2col">
                <div className="fin-card"><div className="fin-card-header"><span className="fin-card-title"><FaTruck size={12}/> Composição de Frete por Canal</span></div><div className="bi-chart-body"><div className="bi-chart-canvas"><Bar data={freteComposicaoData} options={CHART_DEFAULTS}/></div></div></div>
                <div className="fin-card"><div className="fin-card-header"><span className="fin-card-title"><FaChartLine size={12}/> Ticket Médio por Canal</span></div><div className="bi-chart-body"><div className="bi-chart-canvas"><Line data={ticketMedioData} options={CHART_DEFAULTS}/></div></div></div>
              </div>
              <div className="fin-section-label">Divisão de pedidos por faixa de valor</div>
              <div className="fin-card" style={{marginBottom:24}}>
                <div className="fin-card-header">
                  <span className="fin-card-title"><FaFilter size={12}/> Pedidos R$19–79 vs Demais</span>
                  <span className="fin-card-sub">Total do período: {summary.totalOrders.toLocaleString('pt-BR')} pedidos</span>
                </div>
                <div className="range-card-body">
                  {(()=>{
                    const total=summary.totalOrders||1, rangePct=pct(summary.totalQtdRange,total)
                    const r=46,cx=60,cy=60,stroke=10,circ=2*Math.PI*r,dash=(rangePct/100)*circ
                    return (
                      <div className="range-svg-wrap">
                        <svg width="120" height="120" viewBox="0 0 120 120">
                          <circle cx={cx} cy={cy} r={r} fill="none" stroke="#f0f1f5" strokeWidth={stroke}/>
                          <circle cx={cx} cy={cy} r={r} fill="none" stroke="#0d9488" strokeWidth={stroke} strokeDasharray={`${dash} ${circ}`} strokeLinecap="round" transform={`rotate(-90 ${cx} ${cy})`}/>
                        </svg>
                        <div className="range-svg-label"><span className="range-svg-pct">{rangePct.toFixed(0)}%</span><span className="range-svg-sub">range</span></div>
                      </div>
                    )
                  })()}
                  <div className="range-legend">
                    <div className="range-legend-row"><div className="range-legend-dot" style={{background:'#0d9488'}}/><span className="range-legend-lbl">Pedidos R$19–79</span><span className="range-legend-val" style={{color:'var(--teal)'}}>{summary.totalQtdRange.toLocaleString('pt-BR')}</span><span className="range-legend-pct">{fmtPct(pct(summary.totalQtdRange,summary.totalOrders||1))}</span></div>
                    <div className="range-legend-row"><div className="range-legend-dot" style={{background:'#e4e7ef'}}/><span className="range-legend-lbl">Demais pedidos</span><span className="range-legend-val" style={{color:'var(--sub)'}}>{(summary.totalOrders-summary.totalQtdRange).toLocaleString('pt-BR')}</span><span className="range-legend-pct">{fmtPct(pct(summary.totalOrders-summary.totalQtdRange,summary.totalOrders||1))}</span></div>
                    <div className="range-legend-row" style={{borderTop:'1px solid var(--border)',paddingTop:10,marginTop:2}}><div className="range-legend-dot" style={{background:'var(--blue)'}}/><span className="range-legend-lbl">Total geral</span><span className="range-legend-val" style={{color:'var(--blue)'}}>{summary.totalOrders.toLocaleString('pt-BR')}</span><span className="range-legend-pct">100%</span></div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* ════════ BI ════════ */}
          {tab === 'bi' && (
            <>
              {loading ? <div className="fin-empty"><div className="fin-spinner"/>Carregando...</div>
              : !biData ? <div className="fin-empty">Nenhum dado.</div>
              : (
                <>
                  <div className="fin-section-label">Insights automáticos</div>
                  <div className="bi-insights">
                    <InsightCard title="Canal líder"          value={biData.topCh?.apelido||'—'}  desc={`Fat. líquido de ${fmtBRL(biData.topCh?.faturamento_liquido)}`} accent="var(--blue)"/>
                    <InsightCard title="Ticket médio geral"   value={fmtBRL(biData.avgTk)}         desc="Valor médio por pedido."             accent="var(--purple)"/>
                    <InsightCard title="Taxa de cancelamento" value={fmtPct(biData.taxaCan)}       desc="Pedidos cancelados sobre total."      accent="var(--red)"/>
                    <InsightCard title="Custo frete / bruto"  value={fmtPct(biData.custoShare)}    desc="Custo frete paid R$19–79 / bruto."   accent="var(--orange)"/>
                    <InsightCard title="Frete real / bruto"   value={fmtPct(biData.freteShare)}    desc="Frete logístico real (>79) / bruto." accent="var(--teal)"/>
                    <InsightCard title="Parts / bruto"        value={fmtPct(biData.partsShare)}    desc="Categoria Parts (id 50) / bruto."    accent="var(--indigo)"/>
                    <InsightCard title="Maior cancelamento"   value={biData.topCan?.apelido||'—'}  desc={`Taxa ${fmtPct(biData.topCan?.percentual_cancelado)}`} accent="var(--red)"/>
                    <InsightCard title="Maior % fullfilment"  value={biData.topFull?.apelido||'—'} desc={`${fmtPct(biData.topFull?.percentual_fullfilment)} fullfilment`} accent="var(--green)"/>
                  </div>
                  <div className="fin-section-label">Funil de receita</div>
                  <div className="fin-card" style={{marginBottom:20}}>
                    <div className="fin-card-header"><span className="fin-card-title"><MdOutlineInsights size={14}/> Composição da Receita</span></div>
                    <div className="bi-funnel">
                      {funnelRows.map((row,i)=>(
                        <div key={i} className="bi-funnel-row">
                          <div className="bi-funnel-label">{row.label}</div>
                          <div className="bi-funnel-bar-track"><div className="bi-funnel-bar-fill" style={{width:`${Math.max(row.pct,3)}%`,background:row.color}}><span className="bi-funnel-bar-text">{fmtBRL(row.value)}</span></div></div>
                          <div className="bi-funnel-pct">{fmtPct(row.pct)}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="bi-2col">
                    {radarData && (
                      <div className="fin-card">
                        <div className="fin-card-header"><span className="fin-card-title"><BsLightningFill size={12}/> Radar de Performance (Top 5)</span></div>
                        <div className="bi-chart-body"><div className="bi-chart-canvas tall"><Radar data={radarData} options={{responsive:true,maintainAspectRatio:false,plugins:{legend:{labels:{color:'#8c94a6',font:{family:'DM Mono',size:10},boxWidth:8}}},scales:{r:{ticks:{color:'#8c94a6',font:{size:9}},grid:{color:'#eef0f5'},pointLabels:{color:'#5b6578',font:{family:'DM Sans',size:10}}}}}}/></div></div>
                      </div>
                    )}
                    <div className="fin-card">
                      <div className="fin-card-header"><span className="fin-card-title">Matriz Canal (Fat. × Cancelamento)</span></div>
                      <div style={{padding:'16px 20px'}}>
                        <div className="bi-matrix">
                          {[
                            {key:'highHigh',label:'⭐ Alto Fat. / Baixo Cancel.',color:'var(--green)',data:quadrants.highHigh},
                            {key:'highLow', label:'⚠️ Alto Fat. / Alto Cancel.',color:'var(--amber)',data:quadrants.highLow},
                            {key:'lowHigh', label:'📈 Baixo Fat. / Baixo Cancel.',color:'var(--blue)',data:quadrants.lowHigh},
                            {key:'lowLow',  label:'🔴 Baixo Fat. / Alto Cancel.',color:'var(--red)',data:quadrants.lowLow},
                          ].map(q=>(
                            <div key={q.key} className="bi-quadrant">
                              <div className="bi-quadrant-label" style={{color:q.color}}>{q.label}</div>
                              <div className="bi-quadrant-items">
                                {q.data.map((i,x)=><div key={x} className="bi-quadrant-item"><div className="bi-quadrant-dot" style={{background:q.color}}/>{i.apelido}</div>)}
                                {!q.data.length && <div className="bi-quadrant-item" style={{color:'var(--muted)'}}>—</div>}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bi-2col">
                    <div className="fin-card"><div className="fin-card-header"><span className="fin-card-title">Cancelamentos por canal</span></div><div className="bi-chart-body"><div className="bi-chart-canvas"><Line data={cancelChartData} options={CHART_DEFAULTS}/></div></div></div>
                    <div className="fin-card"><div className="fin-card-header"><span className="fin-card-title">Pedidos Full por canal</span></div><div className="bi-chart-body"><div className="bi-chart-canvas"><Line data={fullOrderChartData} options={CHART_DEFAULTS}/></div></div></div>
                  </div>
                </>
              )}
            </>
          )}

          {/* ════════ POR CANAL ════════ */}
          {tab === 'channels' && (
            <>
              <div className="fin-section-label">Desempenho por canal de venda</div>
              <div className="fin-card">
                <div className="fin-card-header">
                  <div><span className="fin-card-title">Marketplace</span><span className="fin-card-sub">{marketplaceData.length} canais</span></div>
                  <div style={{display:'flex',gap:8,alignItems:'center'}}>
                    <select className="fin-select" value={sortBy} onChange={e=>setSortBy(e.target.value)}>
                      <option value="faturamento_liquido">Ordenar: Fat. Líquido</option>
                      <option value="faturamento_bruto">Ordenar: Fat. Bruto</option>
                      <option value="total_pedidos">Ordenar: Pedidos</option>
                      <option value="ticket_medio">Ordenar: Ticket Médio</option>
                      <option value="percentual_cancelado">Ordenar: % Cancel.</option>
                      <option value="total_fullfilment">Ordenar: Fullfilment</option>
                    </select>
                    <button className="fin-btn-ghost" onClick={generatePDF} disabled={selectedAccounts.length===0}>
                      <FaFilePdf size={11}/> PDF {selectedAccounts.length>0&&`(${selectedAccounts.length})`}
                    </button>
                  </div>
                </div>

                {loading ? <div className="fin-empty"><div className="fin-spinner"/>Carregando...</div>
                : sortedData.length===0 ? <div className="fin-empty"><span style={{fontSize:28,opacity:.3}}>📭</span>Nenhum dado.</div>
                : (
                  <div className="channels-table-container">
                    <table>
                      <thead>
                        <tr>
                          <th style={{width:32}}>#</th>
                          <th style={{minWidth:100}}>Marketplace</th>
                          <th className="r" style={{minWidth:90}}>Fat. Bruto</th>
                          <th className="r" style={{minWidth:90}}>Frete Real</th>
                          <th className="r col-custo" style={{minWidth:100}}>Custo Frete</th>
                          <th className="r" style={{minWidth:90}}>Fat. Líquido</th>
                          <th className="r" style={{minWidth:80}}>Parts</th>
                          <th className="r" style={{minWidth:85}}>Ticket Médio</th>
                          <th className="c" style={{minWidth:45}}>Full</th>
                          <th className="c" style={{minWidth:60}}>Pedidos</th>
                          <th style={{minWidth:85}}>% Full</th>
                          <th style={{minWidth:90}}>Qtd R$19–79</th>
                          <th className="r" style={{minWidth:85}}>Val. Cancel.</th>
                          <th className="c" style={{minWidth:65}}>Qtd Cancel.</th>
                          <th style={{minWidth:80}}>% Cancel.</th>
                          <th style={{width:30}}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedData.map((item,idx)=>{
                          const cancPct=item.percentual_cancelado||0
                          const heatClass=item.faturamento_liquido>(summary.totalNetRevenue/(sortedData.length||1))*1.3?'heat-high':cancPct>5?'heat-low':''
                          return (
                            <tr key={idx} className={`${idx===0?'top-row':''} ${heatClass}`}>
                              <td><span className={`rank ${idx===0?'rank-1':'rank-n'}`}>{idx+1}</span></td>
                              <td style={{fontWeight:600,fontSize:12}}>
                                {item.apelido}
                                {idx===0&&<span className="chip chip-blue">Top</span>}
                                {cancPct>5&&<span className="chip chip-red">⚠</span>}
                              </td>
                              <td className="mono r">{fmt(item.faturamento_bruto)}</td>
                              <td className="mono r">{fmt(item.frete_real)}</td>
                              <td className="mono r col-custo-cell">{fmt(item.frete_paid_range||0)}</td>
                              <td className="mono r" style={{color:'var(--green)',fontWeight:600}}>{fmt(item.faturamento_liquido)}</td>
                              <td className="mono r">{fmt(item.valor_parts)}</td>
                              <td className="mono r">{fmt(item.ticket_medio)}</td>
                              <td className="mono c">{item.total_fullfilment}</td>
                              <td className="mono c">{item.total_pedidos}</td>
                              <td>
                                <div className="pbar">
                                  <div className="pbar-track"><div className="pbar-fill" style={{width:`${Math.min(item.percentual_fullfilment||0,100)}%`}}/></div>
                                  <span className="pbar-text">{(item.percentual_fullfilment||0).toFixed(1)}%</span>
                                </div>
                              </td>
                              <td>
                                <div style={{display:'flex',flexDirection:'column',gap:2}}>
                                  <div style={{display:'flex',alignItems:'baseline',gap:3}}>
                                    <span style={{fontFamily:'var(--mono)',fontSize:12,fontWeight:700,color:'var(--teal)'}}>{item.qtd_pedidos_range||0}</span>
                                    <span style={{fontFamily:'var(--mono)',fontSize:10,color:'var(--muted)'}}>/{item.total_pedidos}</span>
                                  </div>
                                  <div style={{display:'flex',alignItems:'center',gap:4}}>
                                    <div style={{width:44,height:3,background:'#f0f1f5',borderRadius:99,overflow:'hidden'}}>
                                      <div style={{height:'100%',width:`${Math.min(pct(item.qtd_pedidos_range||0,item.total_pedidos||1),100)}%`,background:'var(--teal)',borderRadius:99}}/>
                                    </div>
                                    <span style={{fontFamily:'var(--mono)',fontSize:10,color:'var(--teal)'}}>{fmtPct(pct(item.qtd_pedidos_range||0,item.total_pedidos||1))}</span>
                                  </div>
                                </div>
                              </td>
                              <td className="mono r" style={{color:'var(--red)'}}>{fmt(item.valor_cancelado)}</td>
                              <td className="mono c">{item.total_cancelado}</td>
                              <td>
                                <div className="pbar">
                                  <div className="pbar-track"><div className="pbar-fill red" style={{width:`${Math.min(cancPct,100)}%`}}/></div>
                                  <span className="pbar-text">{cancPct.toFixed(1)}%</span>
                                </div>
                              </td>
                              <td className="c"><input type="checkbox" className="fin-check" checked={selectedAccounts.includes(item.apelido)} onChange={()=>toggleSelection(item.apelido)}/></td>
                            </tr>
                          )
                        })}
                      </tbody>
                      <tfoot>
                        <tr className="total-row">
                          <td colSpan={2} style={{textAlign:'right',paddingRight:12}}>Total</td>
                          <td className="r">{fmt(summary.totalGrossRevenue)}</td>
                          <td className="r">{fmt(summary.totalFreightValue)}</td>
                          <td className="r">{fmt(summary.totalCustoFrete)}</td>
                          <td className="r">{fmt(summary.totalNetRevenue)}</td>
                          <td className="r">{fmt(summary.totalParts)}</td>
                          <td/><td/>
                          <td className="c">{summary.totalOrders.toLocaleString('pt-BR')}</td>
                          <td/>
                          <td style={{color:'var(--teal)'}}>{summary.totalQtdRange.toLocaleString('pt-BR')}</td>
                          <td className="r">{fmt(summary.totalCanceledValue)}</td>
                          <td/><td/><td/>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                )}
              </div>
            </>
          )}

          {/* ════════ SKU / CURVA ABC ════════ */}
          {tab === 'sku' && (
            <>
              <div className="fin-section-label">Curva ABC — Análise de Pareto por Produto</div>
              <div className="abc-summary">
                <div className="abc-summary-card abc-a">
                  <div className="abc-summary-label">Classe A — Vitais (0–80%)</div>
                  <div className="abc-summary-value" style={{color:'var(--green)'}}>{fmtBRL(abcResumo.A.valor)}</div>
                  <div className="abc-summary-sub">{abcResumo.A.qtdSkus} SKUs · {fmtPct(abcResumo.A.pctSkus)} do catálogo<br/>Concentram ~80% do faturamento</div>
                </div>
                <div className="abc-summary-card abc-b">
                  <div className="abc-summary-label">Classe B — Importantes (80–95%)</div>
                  <div className="abc-summary-value" style={{color:'var(--blue)'}}>{fmtBRL(abcResumo.B.valor)}</div>
                  <div className="abc-summary-sub">{abcResumo.B.qtdSkus} SKUs · {fmtPct(abcResumo.B.pctSkus)} do catálogo<br/>Concentram ~15% do faturamento</div>
                </div>
                <div className="abc-summary-card abc-c">
                  <div className="abc-summary-label">Classe C — Acessórios (95–100%)</div>
                  <div className="abc-summary-value" style={{color:'var(--orange)'}}>{fmtBRL(abcResumo.C.valor)}</div>
                  <div className="abc-summary-sub">{abcResumo.C.qtdSkus} SKUs · {fmtPct(abcResumo.C.pctSkus)} do catálogo<br/>Concentram ~5% do faturamento</div>
                </div>
              </div>
              <div className="fin-card" style={{marginBottom:20}}>
                <div className="fin-card-header">
                  <span className="fin-card-title"><BsGraphUp size={13}/> Diagrama de Pareto — Top {Math.min(abcData.length,25)} SKUs</span>
                  <span className="fin-card-sub">
                    <span style={{color:'var(--green)',fontWeight:700}}>■</span> Classe A &nbsp;
                    <span style={{color:'var(--blue)',fontWeight:700}}>■</span> Classe B &nbsp;
                    <span style={{color:'var(--orange)',fontWeight:700}}>■</span> Classe C &nbsp;
                    <span style={{color:'var(--purple)',fontWeight:700}}>—</span> % acumulado
                  </span>
                </div>
                <div className="bi-chart-body"><div className="bi-chart-canvas tall">{abcData.length>0?<Bar data={paretoChartData} options={paretoOptions}/>:<div className="fin-empty">Nenhum dado para o período.</div>}</div></div>
              </div>
              <div className="fin-card">
                <div className="fin-card-header">
                  <span className="fin-card-title"><BsTable size={12}/> Classificação ABC por SKU</span>
                  <div style={{display:'flex',gap:10,alignItems:'center',flexWrap:'wrap'}}>
                    <div style={{display:'flex',gap:4}}>
                      {['Todas','A','B','C'].map(cls=>(
                        <button key={cls} onClick={()=>setAbcFiltro(cls)} className="bi-filter-chip" style={abcFiltro===cls?{borderColor:'var(--blue)',color:'var(--blue)',background:'var(--blue-lt)',fontWeight:700}:{}}>
                          {cls==='Todas'?'Todas':<span style={{display:'flex',alignItems:'center',gap:5}}><span className={`abc-badge abc-${cls.toLowerCase()}`} style={{width:16,height:16,fontSize:9}}>{cls}</span>Classe {cls}</span>}
                        </button>
                      ))}
                    </div>
                    <select className="fin-select" value={categoriaSelecionada} onChange={e=>setCategoriaSelecionada(e.target.value)}>
                      {categorias.map((c,i)=><option key={i} value={c}>{c}</option>)}
                    </select>
                    <button className="fin-btn-sm" onClick={gerarPDF}><BsDownload size={11}/> PDF</button>
                  </div>
                </div>
                <div className="fin-table-wrap">
                  {abcDataFiltrado.length===0
                    ? <div className="fin-empty"><span style={{fontSize:28,opacity:.3}}>📭</span>Nenhum item.</div>
                    : (
                      <table className="fin-table">
                        <thead><tr>
                          <th style={{width:36}}>#</th><th style={{width:40}}>ABC</th><th>SKU</th><th>Descrição</th><th>Categoria</th><th>Canais</th><th>Qtd</th><th>Faturamento</th><th>% Individual</th><th>% Acumulado</th><th style={{minWidth:130}}>Participação</th>
                        </tr></thead>
                        <tbody>
                          {abcDataFiltrado.map((item,idx)=>(
                            <tr key={idx} style={{background:item.classe==='A'?'rgba(5,150,105,.035)':item.classe==='B'?'rgba(37,99,235,.025)':'transparent'}}>
                              <td className="mono center" style={{color:'var(--muted)',fontSize:11}}>{item.idx}</td>
                              <td className="center"><span className={`abc-badge abc-${item.classe.toLowerCase()}`}>{item.classe}</span></td>
                              <td className="mono" style={{color:'var(--sub)',fontSize:11,maxWidth:90,overflow:'hidden',textOverflow:'ellipsis'}}>{item.sku}</td>
                              <td style={{fontWeight:item.classe==='A'?600:400,maxWidth:240,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{item.descricao}</td>
                              <td style={{color:'var(--muted)',fontSize:12}}>{item.categoria}</td>
                              <td className="mono center">{item.contas}</td>
                              <td className="mono right">{Number(item.quantidade).toFixed(2)}</td>
                              <td className="mono right" style={{fontWeight:600,color:item.classe==='A'?'var(--green)':item.classe==='B'?'var(--blue)':'var(--orange)'}}>R$ {item.valor.toLocaleString('pt-BR',{minimumFractionDigits:2})}</td>
                              <td className="mono right" style={{color:'var(--sub)'}}>{item.pctIndividual.toFixed(2)}%</td>
                              <td className="mono right" style={{color:'var(--purple)',fontWeight:item.pctAcumulado<=80?700:item.pctAcumulado<=95?600:400}}>{item.pctAcumulado.toFixed(1)}%</td>
                              <td>
                                <div style={{display:'flex',alignItems:'center',gap:6}}>
                                  <div style={{flex:1,height:5,background:'#f0f1f5',borderRadius:99,overflow:'hidden'}}>
                                    <div style={{height:'100%',width:`${Math.min(item.pctIndividual*5,100)}%`,borderRadius:99,background:item.classe==='A'?'linear-gradient(90deg,#059669,#10b981)':item.classe==='B'?'linear-gradient(90deg,#2563eb,#60a5fa)':'linear-gradient(90deg,#ea580c,#fb923c)'}}/>
                                  </div>
                                  <span style={{fontFamily:'var(--mono)',fontSize:10,color:'var(--muted)',flexShrink:0,width:38,textAlign:'right'}}>{item.pctIndividual.toFixed(1)}%</span>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr className="total-row">
                            <td colSpan={7} style={{textAlign:'right',paddingRight:16}}>Total — {abcDataFiltrado.length} SKUs {abcFiltro!=='Todas'?`(Classe ${abcFiltro})`:''}</td>
                            <td className="right">R$ {abcDataFiltrado.reduce((s,i)=>s+i.valor,0).toLocaleString('pt-BR',{minimumFractionDigits:2})}</td>
                            <td className="mono right">{abcDataFiltrado.reduce((s,i)=>s+i.pctIndividual,0).toFixed(1)}%</td>
                            <td/><td/>
                          </tr>
                        </tfoot>
                      </table>
                    )
                  }
                </div>
              </div>
              <div className="fin-section-label" style={{marginTop:8}}>Detalhe por transação</div>
              <div className="fin-card">
                <div className="fin-card-header"><span className="fin-card-title">Vendas por SKU — Detalhe por conta</span></div>
                <div className="fin-table-wrap">
                  <table className="fin-table">
                    <thead><tr><th>Conta</th><th>SKU</th><th>Descrição</th><th>V. Unitário</th><th>Qtd</th><th>Total</th><th>Data</th></tr></thead>
                    <tbody>
                      {Object.entries(groupedData).map(([apelido,group],idx)=>(
                        <React.Fragment key={idx}>
                          {group.items.slice().sort((a,b)=>new Date(b.data)-new Date(a.data)).map((item,i)=>(
                            <tr key={i}>
                              <td style={{fontWeight:500}}>{item.apelido}</td>
                              <td className="mono" style={{color:'var(--muted)'}}>{item.sku}</td>
                              <td>{item.descricao}</td>
                              <td className="mono right" style={{color:'var(--green)'}}>R$ {item?.valorunitario?.toFixed(2)}</td>
                              <td className="mono center">{Number(item?.quantidade_nova)?.toFixed(2)}</td>
                              <td className="mono right" style={{color:'var(--blue)',fontWeight:600}}>R$ {item?.valor_novo?.toFixed(2)}</td>
                              <td className="mono" style={{color:'var(--muted)'}}>{new Date(item.data).toLocaleDateString('pt-BR')}</td>
                            </tr>
                          ))}
                          <tr className="subtotal-row">
                            <td colSpan="5" style={{textAlign:'right',paddingRight:20}}>Subtotal — {apelido}</td>
                            <td className="right">R$ {group?.total?.toFixed(2)}</td>
                            <td/>
                          </tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="total-row">
                        <td colSpan="5" style={{textAlign:'right',paddingRight:20}}>Total das Vendas</td>
                        <td className="right">R$ {totalVendas?.toFixed(2)}</td>
                        <td/>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default Financial